<template>
  <svg width="2em" height="2em" viewBox="0 0 12 14" xmlns="http://www.w3.org/2000/svg">
    <path d="M5.33333 5.00016H4V0.333496H2.66667V5.00016H1.33333V0.333496H0V5.00016C0 6.4135 1.10667 7.56016 2.5 7.64683V13.6668H4.16667V7.64683C5.56 7.56016 6.66667 6.4135 6.66667 5.00016V0.333496H5.33333V5.00016ZM8.66667 3.00016V8.3335H10.3333V13.6668H12V0.333496C10.16 0.333496 8.66667 1.82683 8.66667 3.00016Z" fill="currentColor"/>
  </svg>
</template>
